import useFormatCurrency from 'hooks/useFormatCurrency';

const useFormattedPrice = (
  price:
    | { value?: string | undefined; currency?: string | undefined }
    | undefined,
): string | null => {
  const formatCurrency = useFormatCurrency();

  if (!price?.value || !price?.currency) {
    return null;
  }

  const currency = price.currency || 'USD';
  const value = Number(price.value || 0);

  if (value >= 1_000_000) {
    return formatCurrency({
      currency,
      value,
      options: {
        maximumFractionDigits: 3,
        minimumFractionDigits: 3,
        notation: 'compact',
        removeDecimals: false,
        round: false,
      },
    });
  }

  if (value >= 100_000) {
    return formatCurrency({
      currency,
      value,
      options: {
        maximumFractionDigits: 1,
        minimumFractionDigits: 1,
        notation: 'compact',
        removeDecimals: false,
        round: true,
      },
    });
  }

  return formatCurrency({
    currency,
    value,
    options: {
      removeDecimals: true,
      round: true,
    },
  });
};

export default useFormattedPrice;
